<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-avatar
        tile
        class="mt-2 mb-2 mr-2 image-icon"
        v-on="on"
        @click="fetchImage"
      >
        <v-progress-circular
          v-if="loading"
          indeterminate
          size="22"
          width="2"
          color="primary"
        />
        <v-img
          v-else-if="item.imageUrl && !imageFailed"
          :src="item.imageUrl"
          contain
          @error="imageFailed = true"
        />
        <v-icon v-else>mdi-image-search-outline</v-icon>
      </v-avatar>
    </template>
    <span>
      {{ item.imageUrl && !imageFailed ? "Category image" : "Find category image" }}
    </span>
  </v-tooltip>
</template>

<script>
import productService from "@/modules/Product/service.js";
import categoryService from "@/modules/Product/Category/service.js";

export default {
  props: ["item", "type"],
  data() {
    return {
      loading: false,
      imageFailed: false,
    };
  },
  watch: {
    "item.imageUrl"() {
      this.imageFailed = false;
    },
  },
  methods: {
    async fetchImage() {
      if (this.loading || (this.item.imageUrl && !this.imageFailed)) return;

      this.loading = true;
      try {
        const searchResponse = await productService.searchProductImages({
          q: this.item.name,
        });
        const searchResult = searchResponse && searchResponse.data
          ? searchResponse.data
          : searchResponse;
        const candidate = searchResult && searchResult.candidates
          ? searchResult.candidates[0]
          : null;
        if (!candidate) throw new Error("No category image found");

        const importResponse = await productService.importProductImage({
          identity: { name: this.item.name },
          sourceUrl: candidate.url,
          sourcePage: candidate.sourcePage || null,
          visibility: "shared_pending",
        });
        const imported = importResponse && importResponse.data
          ? importResponse.data
          : importResponse;
        if (!imported || !imported.imageUrl) throw new Error("Image import failed");

        if (this.type !== "category") throw new Error("Unsupported image relation");
        await categoryService.update(this.item.id, { imageUrl: imported.imageUrl });
        this.$set(this.item, "imageUrl", imported.imageUrl);
        this.imageFailed = false;
        this.$emit("updated", this.item);
      } catch (error) {
        this.$swal({
          icon: "info",
          title: "No category image found",
          text: "Edit the category to search again or upload an image.",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.image-icon {
  cursor: pointer;
  background: #f1f5f9;
}
</style>
